import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { PublicationCardDetailContainerProps } from "../../interfaces/containers";
import EntryPoint from "../../components/PublicationCardDetail";

function mapStateToProps(state: PublicationCardDetailContainerProps) {
    return{
        publication: state.profile.publication
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);